// @flow @jsx h

import { h } from 'preact'
import styles from './Counter.css'

type Props = {
  amount: string,
  afterText: string
}

export const Counter = ({ amount, afterText }: Props) => {
  const amountInTon = String(amount).replace('.', ',')
  return (
    <span className={styles.counter}>
      {amountInTon.split('').map((v, i) => (
        <span class={v === ',' ? '' : styles.counter__number} key={v + '' + i}>
          {v}
        </span>
      ))}
      {afterText}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Counter.js